import {mapState} from "vuex";
export default {
    props: ['type', 'index'],
    data() {
        return {
            teamName: null,
            playerName: null,
            gender: null,
            dateBirthYear: 1980,
            dateBirthMonth: null,
            dateBirthDate: null,
            mobileFirst: '010',
            mobileSecond: null,
            mobileLast: null,
            playerType: this.type,
            playerIndex: this.index,
            productId : null,
            productList : [],
            yearList: []
            
        }
    },
    watch: {
        type: function (newVal) {
            this.playerType = newVal
        },
        index: function (newVal) {
            this.playerIndex = newVal
        }
    },
    methods: {
        firstPhoneChangeFnc(){
            this.mobileFirst = this.onlyNumberReplaceFunc(this.mobileFirst)
            this.mobileFirst = this.mobileFirst.substr(0,3)
            if(this.mobileFirst.length === 3){
                this.$refs.mobileSecond.focus()
            }
            this.changePlayerInfoFunc()
        },
        secondPhoneChangeFunc(){
            this.mobileSecond = this.onlyNumberReplaceFunc(this.mobileSecond)
            this.mobileSecond = this.mobileSecond.substr(0,4)
            if(this.mobileSecond.length === 4){
                this.$refs.mobileLast.focus()
            }
            this.changePlayerInfoFunc()
        },
        lastPhoneChangeFunc(){
            this.mobileLast = this.onlyNumberReplaceFunc(this.mobileLast)
            this.mobileLast = this.mobileLast.substr(0,4)

            this.changePlayerInfoFunc()
        },
        changePlayerInfoFunc() {
            
            const temp = {
                "playerName": this.playerName,
                "mobile": `${this.mobileFirst||''}${this.mobileSecond||''}${this.mobileLast||''}`,
                "gender": this.gender,
                "dateOfBirth": `${this.dateBirthYear||''}${this.dateBirthMonth||''}${this.dateBirthDate||''}`,
                "teamName": this.teamName,
                "type": this.playerType,
                "productId" : this.productId
            }

            this.$emit('input', temp)
        },
    },
    computed: {
        ...mapState('tournaments', ['tournament']),
    },
    mounted(){
        this.productList = this.tournament.productList
    },
    created(){
        const date = new Date();

        const year = date.getFullYear()

        for(let i = (year-100); i<=year; i++){
            this.yearList.push(i)
        }        
    },
   
}
